export default {
  overviewTitle: 'CronLogs',
  detailTitle: 'CronLog',
  deleteTitle: 'dit CronLog',
  url: '/manage/cronlogs',
  apiUrl: '/cronlogs/',
  sortBy: ['timestamp'],
  sortDesc: [true],
  deletable: true,
  editable: true,
  filterName: 'manage/cronlogs',
  quickFilter: {
    text: 'Zoek op timestamp',
    value: 'timestamp',
    type: 'text'
  },
  newRecord: {
  },
  // isReadOnlyOverview: true,
  // customEditable(item) {
  //   return false;
  // },
  // customDeletable(item) {
  //   return false;
  // },
  advancedSearchFields: [
    {text: 'HasErrors', value: 'has_errors', type: 'boolean', columns: 2, labelCols: 3, inputCols: 2},
    {text: 'Timestamp >=', value: 'timestamp_date_ge', type: 'date', columns: 2, labelCols: 6, inputCols: 6},
    {text: 'Timestamp <=', value: 'timestamp_date_le', type: 'date', columns: 2, labelCols: 6, inputCols: 6},
    {text: 'Func_Name', value: 'func_name', columns: 6, labelCols: 3, inputCols: 6}
  ],
  tableFields: [
    {text: 'Timestamp', value: 'timestamp', link: '/manage/cronlogs/{id}', width: '10%'},
    {text: 'Error_Count', value: 'error_count', width: '10%'},
    {text: 'Func_Name', value: 'func_name', width: '10%'},
    {text: 'Args', value: 'args', width: '10%'}
    // {text: 'Full_Name', value: 'user_full_name', width: '10%'}
  ]
};
